<template>
  <button
    type="button"
    class="flex h-10 min-w-10 cursor-pointer items-center justify-center rounded-xl border border-stone-200/90 bg-white/90 text-stone-800 hover:border-amber-500/45 hover:text-amber-900 dark:border-white/10 dark:bg-white/[0.06] dark:text-[#dfc06e] dark:hover:border-[rgba(242,216,150,0.4)] dark:hover:text-[#f2d896]"
    :aria-label="isDark ? $t('theme.toLight') : $t('theme.toDark')"
    :title="isDark ? $t('theme.toLight') : $t('theme.toDark')"
    @click="toggleTheme"
  >
    <svg
      v-if="isDark"
      class="h-5 w-5 shrink-0"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <path
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
        d="M12 3v2.25m6.364.386-1.591 1.591M21 12h-2.25m-.386 6.364-1.591-1.591M12 18.75V21m-4.773-4.227-1.591 1.591M5.25 12H3m4.227-4.773L5.636 5.636M15.75 12a3.75 3.75 0 11-7.5 0 3.75 3.75 0 017.5 0z"
      />
    </svg>
    <svg
      v-else
      class="h-5 w-5 shrink-0"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <path
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
        d="M21.752 15.002A9.72 9.72 0 0118 15.75c-5.385 0-9.75-4.365-9.75-9.75 0-1.33.266-2.597.748-3.752A9.753 9.753 0 003 11.25C3 16.635 7.365 21 12.75 21a9.753 9.753 0 009.002-5.998z"
      />
    </svg>
  </button>
</template>

<script setup lang="ts">
const { isDark, toggleTheme } = useTheme()
</script>
